(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function toArray(collection) {
    return Array.prototype.slice.call(collection || []);
  }

  function normalize(value) {
    return String(value == null ? '' : value).replace(/\s{2,}/g, ' ');
  }

  function initializeProductSharing(root) {
    var button = root.querySelector('[data-bpc-copy-link]');
    var label = button ? button.querySelector('[data-bpc-copy-label]') : null;
    var status = root.querySelector('[data-bpc-copy-status]');
    var resetTimer = null;

    if (!button || button.getAttribute('data-bpc-copy-ready') === 'true') {
      return;
    }

    function report(success) {
      window.clearTimeout(resetTimer);

      if (label) {
        label.textContent = success ? 'Copied' : 'Try again';
      }
      if (status) {
        status.textContent = success ? 'Product link copied to clipboard.' : 'The product link could not be copied.';
      }

      resetTimer = window.setTimeout(function () {
        if (label) label.textContent = 'Copy link';
      }, 1800);
    }

    function fallbackCopy(url) {
      var field = document.createElement('textarea');
      var success = false;

      field.value = url;
      field.setAttribute('readonly', 'readonly');
      field.style.position = 'fixed';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();

      try {
        success = document.execCommand('copy');
      } catch (error) {
        success = false;
      }

      document.body.removeChild(field);
      report(success);
    }

    button.addEventListener('click', function () {
      var url = button.getAttribute('data-copy-url') || window.location.href;

      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(url).then(function () {
          report(true);
        }).catch(function () {
          fallbackCopy(url);
        });
      } else {
        fallbackCopy(url);
      }
    });

    button.setAttribute('data-bpc-copy-ready', 'true');
  }

  function getVariantOptions(variant) {
    if (variant.options && variant.options.length) {
      return variant.options.map(normalize);
    }

    return [variant.option1, variant.option2, variant.option3]
      .filter(function (value) { return value != null; })
      .map(normalize);
  }

  ready(function () {
    var root = document.querySelector('.bpc-product[data-section-id]');

    if (!root) {
      return;
    }

    initializeProductSharing(root);

    var sectionId = root.getAttribute('data-section-id');
    var productJsonNode = document.getElementById('ProductJson-' + sectionId);
    var product;

    try {
      product = productJsonNode ? JSON.parse(productJsonNode.textContent) : null;
    } catch (error) {
      product = null;
    }

    if (!product || !product.variants) {
      return;
    }

    var form = root.querySelector('form[action*="/cart/add"]');
    var masterSelect = form ? form.querySelector('select[name="id"]') : null;
    var optionSelects = form ? toArray(form.querySelectorAll('.single-option-selector')) : [];
    var addButton = root.querySelector('#AddToCart-' + sectionId);
    var addButtonText = root.querySelector('#AddToCartText-' + sectionId);
    var stock = root.querySelector('[data-bpc-stock]');
    var stockRow = stock ? stock.closest('.bpc-product-stock') : null;
    var saleBadge = root.querySelector('[data-bpc-sale-badge]');
    var comparePrice = root.querySelector('#ComparePrice-' + sectionId);
    var variantStatus = root.querySelector('[data-bpc-variant-status]');
    var purchaseStatus = root.querySelector('[data-bpc-purchase-status]');
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    var quantityMinus = form ? form.querySelector('[data-type="minus"]') : null;
    var pendingPurchase = false;
    var currentVariant = null;

    function selectedOptions() {
      return optionSelects.map(function (select) {
        return normalize(select.value);
      });
    }

    function variantForOptions(options) {
      var match = null;

      product.variants.some(function (variant) {
        var variantOptions = getVariantOptions(variant);
        var isMatch = options.length === variantOptions.length;

        if (isMatch) {
          options.some(function (option, index) {
            if (option !== variantOptions[index]) {
              isMatch = false;
              return true;
            }
            return false;
          });
        }

        if (isMatch) {
          match = variant;
          return true;
        }

        return false;
      });

      return match;
    }

    function selectedVariant() {
      var masterValue = masterSelect ? String(masterSelect.value) : '';
      var match = null;

      if (optionSelects.length) {
        return variantForOptions(selectedOptions());
      }

      if (masterValue) {
        product.variants.some(function (variant) {
          if (String(variant.id) === masterValue) {
            match = variant;
            return true;
          }
          return false;
        });
      }

      return match || variantForOptions(selectedOptions());
    }

    function stateForValue(optionIndex, value, choices) {
      var exists = false;
      var available = false;

      product.variants.some(function (variant) {
        var variantOptions = getVariantOptions(variant);
        var matches = variantOptions[optionIndex] === value;
        var index;

        if (matches) {
          for (index = 0; index < optionIndex; index += 1) {
            if (choices[index] && variantOptions[index] !== choices[index]) {
              matches = false;
              break;
            }
          }
        }

        if (matches) {
          exists = true;
          if (variant.available) {
            available = true;
            return true;
          }
        }

        return false;
      });

      if (available) {
        return 'available';
      }
      if (exists) {
        return 'soldout';
      }
      return 'unavailable';
    }

    function updateSwatches(choices) {
      toArray(root.querySelectorAll('.swatch[data-option-index]')).forEach(function (group) {
        var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
        var currentValue = choices[optionIndex] || '';
        var currentLabel = group.querySelector('[data-bpc-option-current]');

        if (currentLabel) {
          currentLabel.textContent = currentValue;
        }

        toArray(group.querySelectorAll('.swatch-element[data-value]')).forEach(function (element) {
          var input = element.querySelector('input[type="radio"]');
          var value = normalize(element.getAttribute('data-value'));
          var state = stateForValue(optionIndex, value, choices);
          var isSelected = value === currentValue;

          element.classList.remove('available', 'soldout', 'unavailable');
          element.classList.add(state);

          if (!input) {
            return;
          }

          input.checked = isSelected;
          input.disabled = state !== 'available';
          input.setAttribute(
            'aria-label',
            value + (state === 'soldout' ? ', sold out' : state === 'unavailable' ? ', unavailable combination' : '')
          );
        });
      });
    }

    function updateQuantity() {
      var quantity;

      if (!quantityInput) {
        return;
      }

      quantity = parseInt(quantityInput.value, 10);
      if (!quantity || quantity < 1) {
        quantityInput.value = '1';
        quantity = 1;
      }

      if (quantityMinus) {
        quantityMinus.disabled = quantity <= 1;
      }
    }

    function setPurchaseAvailability(variant) {
      var state;
      var label;

      if (!variant) {
        state = 'unavailable';
        label = window.theme && window.theme.strings ? window.theme.strings.unavailable : 'Unavailable';
      } else if (!variant.available) {
        state = 'sold-out';
        label = window.theme && window.theme.strings ? window.theme.strings.soldOut : 'Sold out';
      } else {
        state = 'available';
        label = window.theme && window.theme.strings ? window.theme.strings.addToCart : 'Add to cart';
      }

      if (stock) {
        stock.textContent = state === 'available' ? 'In stock' : state === 'sold-out' ? 'Sold out' : 'Unavailable';
      }

      if (stockRow) {
        stockRow.classList.toggle('is-sold-out', state === 'sold-out');
        stockRow.classList.toggle('is-unavailable', state === 'unavailable');
      }

      if (addButton && !pendingPurchase) {
        addButton.disabled = state !== 'available';
        addButton.removeAttribute('aria-busy');
      }

      if (addButtonText && !pendingPurchase) {
        addButtonText.textContent = label;
      }

      toArray(form ? form.querySelectorAll('.shopify-payment-button') : []).forEach(function (button) {
        button.style.display = state === 'available' ? '' : 'none';
      });

      return state;
    }

    function updateSalePresentation(variant) {
      var onSale = !!(variant && variant.compare_at_price && variant.compare_at_price > variant.price);

      if (comparePrice) {
        comparePrice.classList.toggle('hide', !onSale);
      }
      if (saleBadge) {
        saleBadge.classList.toggle('hide', !onSale);
      }
    }

    function announceVariant(variant, state, choices) {
      if (!variantStatus) {
        return;
      }

      if (!variant) {
        variantStatus.textContent = 'That option combination is unavailable.';
        return;
      }

      variantStatus.textContent = choices.join(', ') + ' selected. ' + (state === 'available' ? 'In stock.' : 'Sold out.');
    }

    function syncVariant() {
      var choices = selectedOptions();
      var state;

      currentVariant = selectedVariant();
      updateSwatches(choices);
      updateSalePresentation(currentVariant);
      state = setPurchaseAvailability(currentVariant);
      announceVariant(currentVariant, state, choices);
      updateQuantity();
    }

    function scheduleSync() {
      window.setTimeout(syncVariant, 0);
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', scheduleSync);
    });

    if (masterSelect) {
      masterSelect.addEventListener('change', scheduleSync);
    }

    if (form) {
      form.addEventListener('change', function (event) {
        if (event.target && (event.target.matches('.swatch input') || event.target.name === 'quantity')) {
          scheduleSync();
        }
      });

      form.addEventListener('click', function (event) {
        var quantityButton = event.target && event.target.closest
          ? event.target.closest('.btn-number[data-type]')
          : null;

        if (!quantityButton || !form.contains(quantityButton)) {
          return;
        }

        /* The legacy quantity buttons update the input through jQuery. */
        window.setTimeout(updateQuantity, 0);
      });

      form.addEventListener('submit', function () {
        if (!currentVariant || !currentVariant.available) {
          return;
        }

        pendingPurchase = true;
        if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-busy', 'true');
        }
        if (addButtonText) {
          addButtonText.textContent = 'Adding...';
        }
        if (purchaseStatus) {
          purchaseStatus.textContent = 'Adding this item to your cart.';
        }

        window.setTimeout(function () {
          if (pendingPurchase) {
            pendingPurchase = false;
            if (purchaseStatus) {
              purchaseStatus.textContent = 'The cart is still updating. Check the cart before trying again.';
            }
            syncVariant();
          }
        }, 12000);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', updateQuantity);
      quantityInput.addEventListener('blur', updateQuantity);
    }

    function wrapCartFeedback() {
      if (!window.Shopify) {
        return;
      }

      var originalLoadQuickCart = window.Shopify.loadQuickCart;
      var originalOnError = window.Shopify.onError;

      if (typeof originalLoadQuickCart === 'function' && !window.Shopify.bpcProductCartFeedbackWrapped) {
        window.Shopify.loadQuickCart = function (cart) {
          if (pendingPurchase) {
            pendingPurchase = false;
            if (purchaseStatus) {
              purchaseStatus.textContent = 'Added to cart. The cart dialog is open.';
            }
            syncVariant();
          }
          return originalLoadQuickCart.apply(this, arguments);
        };
        window.Shopify.bpcProductCartFeedbackWrapped = true;
      }

      if (typeof originalOnError === 'function' && !window.Shopify.bpcProductErrorFeedbackWrapped) {
        window.Shopify.onError = function (request) {
          var message = 'This item could not be added. Review your choices and try again.';
          var response;

          if (pendingPurchase) {
            pendingPurchase = false;
            try {
              response = JSON.parse(request.responseText);
              if (response && response.description) {
                message = response.description;
              }
            } catch (error) {
              response = null;
            }

            if (purchaseStatus) {
              purchaseStatus.textContent = message;
            }
            syncVariant();
          }

          return originalOnError.apply(this, arguments);
        };
        window.Shopify.bpcProductErrorFeedbackWrapped = true;
      }
    }

    function detachLegacyStickyGallery() {
      var slider = root.querySelector('.slider-' + sectionId);

      if (!slider) {
        return;
      }

      slider.style.height = '';
      slider.style.minHeight = '';

      if (window.jQuery && window.jQuery.fn) {
        try {
          window.jQuery(slider).trigger('sticky_kit:detach');
        } catch (error) {
          return;
        }
      }
    }

    function initMissingSwatchFallbacks() {
      toArray(root.querySelectorAll('[data-bpc-swatch-image]')).forEach(function (swatch) {
        var source = swatch.getAttribute('data-bpc-swatch-image');
        var testImage;

        if (!source) {
          return;
        }

        testImage = new Image();
        testImage.onload = function () {
          if (!testImage.naturalWidth) {
            testImage.onerror();
          }
        };
        testImage.onerror = function () {
          var color = window.getComputedStyle(swatch).backgroundColor;
          swatch.style.backgroundImage = 'none';

          if (!color || color === 'transparent' || color === 'rgba(0, 0, 0, 0)') {
            swatch.classList.add('bpc-swatch-image-missing');
          }
        };
        testImage.src = source;
      });
    }

    function activeGalleryIndex() {
      var gallery = root.querySelector('.thumbnails-swipper-container, #swiper-main');
      var active = gallery ? gallery.querySelector('.swiper-slide-active') : null;
      var index;
      var originalSlides;

      if (!active) {
        return 0;
      }

      index = parseInt(active.getAttribute('data-swiper-slide-index'), 10);
      if (!isNaN(index)) {
        return index;
      }

      originalSlides = toArray(gallery.querySelectorAll('.swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)'));
      index = originalSlides.indexOf(active);
      return index < 0 ? 0 : index;
    }

    function syncGalleryAccessibility() {
      var thumbnails = toArray(root.querySelectorAll('[data-bpc-product-thumbnail]'));
      var index = activeGalleryIndex();
      var count = root.querySelector('[data-bpc-media-count]');
      var gallery = root.querySelector('.thumbnails-swipper-container, #swiper-main');
      var swiper = gallery ? gallery.swiper : null;
      var previousButton = root.querySelector('[data-bpc-gallery-previous]');
      var nextButton = root.querySelector('[data-bpc-gallery-next]');
      var hasMultipleImages = !!(product.images && product.images.length > 1);
      var loops = !!(swiper && swiper.params && swiper.params.loop);

      thumbnails.forEach(function (thumbnail, thumbnailIndex) {
        if (thumbnailIndex === index) {
          thumbnail.setAttribute('aria-current', 'true');
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });

      if (count && product.images && product.images.length) {
        count.textContent = Math.min(index + 1, product.images.length) + ' / ' + product.images.length;
      }

      if (previousButton) {
        previousButton.disabled = !hasMultipleImages || !!(swiper && !loops && swiper.isBeginning);
        previousButton.setAttribute('aria-disabled', previousButton.disabled ? 'true' : 'false');
      }

      if (nextButton) {
        nextButton.disabled = !hasMultipleImages || !!(swiper && !loops && swiper.isEnd);
        nextButton.setAttribute('aria-disabled', nextButton.disabled ? 'true' : 'false');
      }
    }

    function initGalleryAccessibility() {
      var gallery = root.querySelector('.thumbnails-swipper-container, #swiper-main');
      var previousButton = root.querySelector('[data-bpc-gallery-previous]');
      var nextButton = root.querySelector('[data-bpc-gallery-next]');
      var zoomButton = root.querySelector('[data-bpc-gallery-zoom]');

      function productZoomItems() {
        var sources = [];

        return toArray(root.querySelectorAll('.zoom-img-wrap [data-srczoom]')).map(function (image) {
          var source = image.getAttribute('data-srczoom');

          if (!source || sources.indexOf(source) !== -1) {
            return null;
          }

          sources.push(source);
          return {
            src: source,
            type: 'image'
          };
        }).filter(function (item) {
          return item !== null;
        });
      }

      function initProductZoomGestures() {
        var wrap = document.querySelector('.mfp-wrap.bpc-product-zoom-dialog');
        var scale = 1;
        var startScale = 1;
        var startDistance = 0;
        var translateX = 0;
        var translateY = 0;
        var panStartX = 0;
        var panStartY = 0;
        var isPinching = false;
        var isPanning = false;
        var hint;

        if (!wrap) {
          return;
        }

        if (typeof wrap.bpcResetPinchZoom === 'function') {
          wrap.bpcResetPinchZoom();
          return;
        }

        function currentImage() {
          return wrap.querySelector('img.mfp-img');
        }

        function touchDistance(touches) {
          var horizontal = touches[0].clientX - touches[1].clientX;
          var vertical = touches[0].clientY - touches[1].clientY;

          return Math.sqrt((horizontal * horizontal) + (vertical * vertical));
        }

        function applyTransform() {
          var image = currentImage();

          if (!image) {
            return;
          }

          if (scale <= 1) {
            image.style.transform = '';
          } else {
            image.style.transform = 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0) scale(' + scale + ')';
          }
        }

        function resetPinchZoom() {
          var image = currentImage();

          scale = 1;
          startScale = 1;
          startDistance = 0;
          translateX = 0;
          translateY = 0;
          isPinching = false;
          isPanning = false;
          wrap.classList.remove('is-pinching');

          if (image) {
            image.style.transform = '';
            image.setAttribute('draggable', 'false');
          }
        }

        wrap.addEventListener('touchstart', function (event) {
          if (event.touches.length === 2) {
            event.preventDefault();
            startDistance = touchDistance(event.touches);
            startScale = scale;
            isPinching = true;
            isPanning = false;
            wrap.classList.add('is-pinching');
          } else if (event.touches.length === 1 && scale > 1) {
            panStartX = event.touches[0].clientX - translateX;
            panStartY = event.touches[0].clientY - translateY;
            isPanning = true;
          }
        }, { passive: false });

        wrap.addEventListener('touchmove', function (event) {
          if (event.touches.length === 2 && isPinching && startDistance > 0) {
            event.preventDefault();
            scale = Math.max(1, Math.min(4, startScale * (touchDistance(event.touches) / startDistance)));

            if (scale === 1) {
              translateX = 0;
              translateY = 0;
            }

            applyTransform();
          } else if (event.touches.length === 1 && isPanning && scale > 1) {
            event.preventDefault();
            translateX = event.touches[0].clientX - panStartX;
            translateY = event.touches[0].clientY - panStartY;
            applyTransform();
          }
        }, { passive: false });

        wrap.addEventListener('touchend', function (event) {
          if (event.touches.length < 2) {
            isPinching = false;
            wrap.classList.remove('is-pinching');
          }

          if (event.touches.length === 1 && scale > 1) {
            panStartX = event.touches[0].clientX - translateX;
            panStartY = event.touches[0].clientY - translateY;
            isPanning = true;
          } else if (!event.touches.length) {
            isPanning = false;
          }

          if (scale < 1.05) {
            resetPinchZoom();
          }
        });

        wrap.addEventListener('touchcancel', resetPinchZoom);
        wrap.addEventListener('dblclick', resetPinchZoom);
        wrap.bpcResetPinchZoom = resetPinchZoom;

        hint = document.createElement('p');
        hint.className = 'bpc-product-zoom-hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = 'Pinch with two fingers to zoom';
        wrap.appendChild(hint);

        resetPinchZoom();
      }

      function labelProductZoomControls() {
        var dialog = document.querySelector('.mfp-wrap.bpc-product-zoom-dialog');
        var close = document.querySelector('.mfp-wrap.bpc-product-zoom-dialog button.mfp-close');
        var previous = document.querySelector('.mfp-wrap.bpc-product-zoom-dialog .mfp-arrow-left');
        var next = document.querySelector('.mfp-wrap.bpc-product-zoom-dialog .mfp-arrow-right');
        var counter = document.querySelector('.mfp-wrap.bpc-product-zoom-dialog .mfp-counter');
        var zoomImage = document.querySelector('.mfp-wrap.bpc-product-zoom-dialog .mfp-img');
        var productTitle = product.title || 'Product';

        if (dialog) {
          dialog.setAttribute('role', 'dialog');
          dialog.setAttribute('aria-modal', 'true');
          dialog.setAttribute('aria-label', 'Images for ' + productTitle);
        }

        if (close) {
          close.setAttribute('aria-label', 'Close image zoom');
        }

        if (previous) {
          previous.setAttribute('aria-label', 'Previous product image');
        }

        if (next) {
          next.setAttribute('aria-label', 'Next product image');
        }

        if (counter) {
          counter.setAttribute('aria-live', 'polite');
        }

        if (zoomImage) {
          zoomImage.setAttribute('alt', productTitle);
        }

        window.setTimeout(initProductZoomGestures, 0);
      }

      toArray(document.querySelectorAll('[data-bpc-product-thumbnail], [data-bpc-related-control]')).forEach(function (control) {
        control.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            control.click();
            window.setTimeout(syncGalleryAccessibility, 30);
          }
        });

        control.addEventListener('click', function () {
          window.setTimeout(syncGalleryAccessibility, 30);
        });
      });

      toArray(root.querySelectorAll('[data-bpc-zoom]')).forEach(function (zoomControl) {
        zoomControl.addEventListener('click', function (event) {
          var wrapper = zoomControl.closest('.zoom-img-wrap');
          var image = wrapper ? wrapper.querySelector('[data-srczoom]') : null;
          var source = image ? image.getAttribute('data-srczoom') : '';
          var items;
          var clickedIndex = 0;
          var itemIndex;

          if (!source || !window.jQuery || !window.jQuery.magnificPopup) {
            return;
          }

          event.preventDefault();
          items = productZoomItems();

          if (!items.length) {
            items = [{ src: source, type: 'image' }];
          }

          for (itemIndex = 0; itemIndex < items.length; itemIndex += 1) {
            if (items[itemIndex].src === source) {
              clickedIndex = itemIndex;
              break;
            }
          }

          window.jQuery.magnificPopup.open({
            items: items,
            index: clickedIndex,
            mainClass: 'mfp-fade bpc-product-zoom-dialog',
            closeBtnInside: false,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="%title%">&#215;</button>',
            tClose: 'Close image zoom',
            fixedContentPos: true,
            image: {
              markup: '<div class="mfp-figure"><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>'
            },
            gallery: {
              enabled: items.length > 1,
              navigateByImgClick: true,
              preload: [1, 1],
              arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%" aria-label="%title%"></button>',
              tPrev: 'Previous product image',
              tNext: 'Next product image',
              tCounter: '%curr% of %total%'
            },
            callbacks: {
              open: labelProductZoomControls,
              change: labelProductZoomControls
            }
          });
        });
      });

      if (previousButton) {
        previousButton.addEventListener('click', function () {
          var swiper = gallery ? gallery.swiper : null;

          if (swiper && typeof swiper.slidePrev === 'function') {
            swiper.slidePrev();
            window.setTimeout(syncGalleryAccessibility, 40);
          }
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          var swiper = gallery ? gallery.swiper : null;

          if (swiper && typeof swiper.slideNext === 'function') {
            swiper.slideNext();
            window.setTimeout(syncGalleryAccessibility, 40);
          }
        });
      }

      if (zoomButton) {
        zoomButton.addEventListener('click', function () {
          var activeSlide = gallery ? gallery.querySelector('.swiper-slide-active') : null;
          var activeZoom = activeSlide ? activeSlide.querySelector('[data-bpc-zoom]') : null;

          if (!activeZoom && gallery) {
            activeZoom = gallery.querySelector('.zoom-img-wrap [data-bpc-zoom]');
          }

          if (activeZoom) {
            activeZoom.click();
          }
        });
      }

      if (gallery && window.MutationObserver) {
        new MutationObserver(syncGalleryAccessibility).observe(gallery, {
          attributes: true,
          attributeFilter: ['class'],
          subtree: true
        });
      }

      syncGalleryAccessibility();
    }

    function initDescription() {
      var details = root.querySelector('[data-bpc-description-details]');

      if (!details) {
        return;
      }

      if (details.getAttribute('data-collapse-mobile') === 'true' && window.matchMedia('(max-width: 767px)').matches) {
        details.removeAttribute('open');
      }
    }

    function syncTabs(tabWrapper) {
      var tabList = tabWrapper.querySelector('.resp-tabs-list');
      var tabs = tabList ? toArray(tabList.children) : [];
      var panels = toArray(tabWrapper.querySelectorAll('.resp-tabs-container > .resp-tab-content'));
      var accordions = toArray(tabWrapper.querySelectorAll('h2.resp-accordion'));

      if (tabList) {
        tabList.setAttribute('role', 'tablist');
      }

      tabs.forEach(function (tab, index) {
        var tabId = 'BpcProductTab-' + sectionId + '-' + index;
        var panelId = 'BpcProductPanel-' + sectionId + '-' + index;
        var active = tab.classList.contains('resp-tab-active');

        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panelId);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');

        if (panels[index]) {
          panels[index].id = panelId;
          panels[index].setAttribute('role', 'tabpanel');
          panels[index].setAttribute('aria-labelledby', tabId);
          panels[index].setAttribute('aria-hidden', active ? 'false' : 'true');
        }
      });

      accordions.forEach(function (accordion) {
        accordion.setAttribute('role', 'button');
        accordion.setAttribute('tabindex', '0');
        accordion.setAttribute('aria-expanded', accordion.classList.contains('resp-tab-active') ? 'true' : 'false');
      });
    }

    function initTabsAccessibility() {
      var tabWrapper = root.querySelector('.product-description-tabs');

      if (!tabWrapper || !tabWrapper.querySelector('.resp-tabs-list')) {
        return false;
      }

      if (tabWrapper.getAttribute('data-bpc-tabs-ready') === 'true') {
        syncTabs(tabWrapper);
        return true;
      }

      tabWrapper.setAttribute('data-bpc-tabs-ready', 'true');
      syncTabs(tabWrapper);

      tabWrapper.addEventListener('click', function () {
        window.setTimeout(function () { syncTabs(tabWrapper); }, 0);
      });

      tabWrapper.addEventListener('keydown', function (event) {
        var target = event.target;
        var tabs;
        var index;
        var destination;

        if (target.getAttribute('role') === 'button' && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          target.click();
          return;
        }

        if (target.getAttribute('role') !== 'tab') {
          return;
        }

        tabs = toArray(tabWrapper.querySelectorAll('[role="tab"]'));
        index = tabs.indexOf(target);

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          destination = tabs[(index + 1) % tabs.length];
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          destination = tabs[(index - 1 + tabs.length) % tabs.length];
        } else if (event.key === 'Home') {
          destination = tabs[0];
        } else if (event.key === 'End') {
          destination = tabs[tabs.length - 1];
        } else if (event.key === 'Enter' || event.key === ' ') {
          destination = target;
        }

        if (destination) {
          event.preventDefault();
          destination.focus();
          destination.click();
        }
      });

      if (window.MutationObserver) {
        new MutationObserver(function () { syncTabs(tabWrapper); }).observe(tabWrapper, {
          attributes: true,
          attributeFilter: ['class', 'style'],
          subtree: true
        });
      }

      return true;
    }

    function preferYotpoReviewSummary() {
      var yotpo = root.querySelector('.bpc-product-summary__reviews');
      var summary = root.querySelector('.bpc-product-summary');

      if (!yotpo || !summary) {
        return;
      }

      function syncReviews() {
        var hasRenderedYotpo = !!yotpo.querySelector('.yotpo-bottomline, .star-clickable, .yotpo-stars');
        summary.classList.toggle('has-yotpo-review-summary', hasRenderedYotpo);
      }

      if (window.MutationObserver) {
        new MutationObserver(syncReviews).observe(yotpo, { childList: true, subtree: true });
      }
      syncReviews();
    }

    function disableMotionAutoplay() {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      toArray(document.querySelectorAll('.swiper-container')).forEach(function (container) {
        var swiper = container.swiper;
        if (swiper && swiper.autoplay && typeof swiper.autoplay.stop === 'function') {
          swiper.autoplay.stop();
        }
      });
    }

    wrapCartFeedback();
    initDescription();
    initMissingSwatchFallbacks();
    initGalleryAccessibility();
    preferYotpoReviewSummary();
    updateQuantity();
    syncVariant();

    window.setTimeout(function () {
      wrapCartFeedback();
      detachLegacyStickyGallery();
      syncVariant();
      initTabsAccessibility();
      disableMotionAutoplay();
    }, 150);

    window.setTimeout(function () {
      detachLegacyStickyGallery();
      syncVariant();
      initTabsAccessibility();
      disableMotionAutoplay();
    }, 650);

    window.addEventListener('resize', function () {
      window.setTimeout(function () {
        detachLegacyStickyGallery();
        disableMotionAutoplay();
      }, 80);
    });
  });
}());
